<template>
  <div style="min-width: 760px">
    <h5 class="mb-3">Общая таблица товаров / услуг</h5>

    <!-- ===== Excel-импорт ===== -->
    <div class="d-flex gap-2 mb-3">
      <input ref="file" type="file" accept=".xlsx,.xls"
             class="form-control form-control-sm w-auto"
             @change="importExcel">
      <button class="btn btn-sm btn-outline-primary" @click="download"
              :disabled="!rows.length">
        <i class="fa-solid fa-download me-1"/>Скачать Excel
      </button>
      <button class="btn btn-sm btn-outline-secondary" @click="addEmpty">
        <i class="fa-solid fa-plus me-1"/>Добавить строку
      </button>
    </div>

    <!-- ===== Таблица ===== -->
    <div class="table-responsive mb-2" v-if="rows.length">
      <table class="table table-sm table-bordered align-middle">
        <thead class="table-light">
          <tr>
            <th style="width:40px">№</th>
            <th>Наименование</th>
            <th style="width:100px">Тип</th>
            <th style="width:120px" class="text-end">Цена</th>
            <th style="width:70px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r,i) in rows" :key="r.id">
            <td>{{ i+1 }}</td>
            <td contenteditable
                @blur="onCellEdit(r,'name',$event)">
              {{ r.name }}
            </td>
            <td contenteditable
                @blur="onCellEdit(r,'type',$event)">
              {{ r.type || '' }}
            </td>
            <td contenteditable class="text-end"
                @blur="onCellEdit(r,'price',$event)">
              {{ r.price }}
            </td>
            <td class="text-center">
              <button class="btn btn-sm btn-link text-danger"
                      title="Удалить" @click="delRow(r.id)">
                <i class="fa-solid fa-trash"/>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="text-muted">Данных пока нет — загрузите Excel.</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import api   from '../api'
import * as XLSX     from 'xlsx'
import { saveAs }    from 'file-saver'

const rows = ref([])

const money = v => v!=null
  ? new Intl.NumberFormat('ru-RU',{style:'currency',currency:'RUB'}).format(v)
  : '—'

/* ---------- загрузка всех строк из всех файлов ---------- */
async function loadRows () {
  const { data: files } = await api.get('/pricelist-files/')
  const result = []
  await Promise.all(files.map(async f => {
    const { data } = await api.get(`/pricelist-files/${f.id}/rows/`)
    data.forEach(r => result.push({
      id:   r.id,
      name: r.item_name,
      type: r.item_type,
      price: r.price
    }))
  }))
  rows.value = result
}

onMounted(loadRows)

/* ---------- Excel → БД ---------- */
const file = ref(null)
async function importExcel (e) {
  const f = e.target.files[0]
  if (!f) return
  const fd = new FormData()
  fd.append('file', f)
  try {
    await api.post('/pricelist-files/upload/', fd)
    await loadRows()
    alert('Данные из Excel загружены')
  } catch (err) {
    console.error(err)
    alert('Не удалось обработать файл')
  } finally {
    file.value.value = ''
  }
}

/* ---------- выгрузка Excel ---------- */
function download () {
  if (!rows.value.length) return
  const data = rows.value.map((r,i)=>({
    'Номер': i+1,
    'Наименование': r.name,
    'Тип': r.type||'',
    'Цена': r.price??''
  }))
  const ws = XLSX.utils.json_to_sheet(data, {
    header:['Номер','Наименование','Тип','Цена']
  })
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb,ws,'Items')
  const buf = XLSX.write(wb,{type:'array',bookType:'xlsx'})
  saveAs(new Blob([buf]), 'all_items.xlsx')
}


async function onCellEdit (row, field, e) {
  const txt = e.target.innerText.trim()
  const val = field==='price' ? Number(txt.replace(',', '.')) : txt
  if (field==='price' && isNaN(val)) {     // защита от “abc”
    e.target.innerText = row.price ?? ''
    return
  }

  if (row[field] === val) return           
  row[field] = val

  await api.patch(`/pricelist-rows/${row.id}/`, {
    item_name: row.name,
    item_type: row.type,
    price:     row.price
  })
}

async function delRow (id) {
  if (!confirm('Удалить строку?')) return
  await api.delete(`/pricelist-rows/${id}/`)
  rows.value = rows.value.filter(r => r.id !== id)
}

async function addEmpty () {
  const { data } = await api.post('/pricelist-rows/', {
    item_name: 'Новый товар',
    item_type: '',
    price:     null
  })
  rows.value.push({
    id:    data.id,
    name:  data.item_name,
    type:  data.item_type,
    price: data.price
  })
}

  
</script>
